import React from 'react';
import { FormattedMessage } from 'react-intl';

import { BlockCopy, PointTitle, BlockContent, Block } from '@components/PDP/pdp.styles';

export const GiftCertificateTerms = () => (
  <Block>
    <PointTitle upperCase>
      <FormattedMessage
        id="giftCertificateTerms.title"
        defaultMessage="Platform gift cards are sold subject to the following terms and conditions:"
      />
    </PointTitle>
    <BlockContent>
      <BlockCopy>
        <FormattedMessage
          id="giftCertificateTerms.valid"
          defaultMessage="Gift cards are valid for 5 years from the date of purchase and can be redeemed against all artworks for sale on Platform. Gift Cards cannot be returned or refunded. If your order exceeds your credit value, any remaining balance must be paid for by credit or debit card. If you return products you have purchased using a Gift Card, the remaining balance will be added to your account as credit and can be redeemed against subsequent orders. Platform is not responsible if a Gift Card is lost, stolen, destroyed or used without your permission."
        />
      </BlockCopy>
      <BlockCopy marginTop={30}>
        <FormattedMessage
          id="giftCertificateTerms.reserve"
          defaultMessage="Platform reserves the right to cancel a Gift Card if we deem such action necessary. Gift Cards are exempt from duty and tax. No delivery charges apply on Gift Card-only orders. If a customer purchases a Gift Card alongside artwork(s), standard delivery charges and taxes will apply on the artwork(s) purchased. Gift Cards cannot be used in conjunction with any other offer."
        />
      </BlockCopy>
    </BlockContent>
  </Block>
);
